import { MediaType, type Vehicle } from '@cobliteam/common-types';
import { z } from 'zod';
import type { PeriodOption, VehicleGroupOption } from './utils';

const FormSchema = z.object({
  vehicleGroup: z.custom<VehicleGroupOption>().refine((val) => !!val, { message: 'Selecione um grupo' }),
  vehicle: z.custom<Vehicle>().refine((val) => !!val, { message: 'Selecione um veículo' }),
  date: z.date({
    required_error: 'Insira uma data',
    invalid_type_error: 'Insira uma data',
  }),
  startTime: z.string(),
  duration: z.number(),
  mediaType: z.enum([MediaType.FOOTAGE_VIDEO, MediaType.TIMELAPSE]),
  period: z.custom<PeriodOption>().optional(),
  enableEmailNotification: z.boolean().optional(),
  tripId: z.string().optional(),
});

type FormSchemaType = z.infer<typeof FormSchema>;

export default FormSchema;
export type { FormSchemaType };
